import {
    request2,
    request1
} from './request.js'
import { ProjectId } from "../common/const.js";
// 获取管理员列表
export function getAdministrators(searchObj, pageIndex, pageSize) {
    return request2({
        url: '/api2/TZsbAdminApi/Admin/GetPage',
        method: 'get',
        params: {
            Name: searchObj.Name,
            Tel: searchObj.Tel,
            RoleId: searchObj.RoleId,
            AdminState: searchObj.AdminState,
            SuperiorAdmin: searchObj.SuperiorAdmin,
            pageIndex: pageIndex,
            pageSize: pageSize
        }
    })
}

// 获取管理员详情
export function getAdminInfo(id) {
    return request2({
        url: '/api2/TZsbAdminApi/Admin/Get',
        method: 'get',
        params: {
            id: id
        }
    })
}

// 添加管理员
export function addAdmin(obj) {
    return request2({
        url: '/api2/TZsbAdminApi/Admin/Add',
        method: 'post',
        data: {
            name: obj.name,
            userName: obj.userName,
            passWord: obj.passWord,
            passWordConfirm: obj.passWordConfirm,
            tel: obj.tel,
            rolesId: obj.rolesId,
            superiorAdmin: obj.superiorAdmin,
            logoPath: obj.logoPath,
            consultUrl: obj.consultUrl,
            ddUserId:obj.ddUserId,
        }
    })
}

// 编辑管理员提交
export function editAdmin(obj) {
    return request2({
        url: '/api2/TZsbAdminApi/Admin/Edit',
        method: 'post',
        data: {
            id: obj.id,
            name: obj.name,
            userName: obj.userName,
            passWord: obj.passWord,
            tel: obj.tel,
            passWordConfirm: obj.newpassWordConfirm,
            isDelete: obj.isDelete,
            weiXinOpenId: obj.weiXinOpenId,
            adminState: obj.adminState,
            superiorAdmin: obj.superiorAdmin,
            rolesId: obj.rolesId,
            logoPath: obj.logoPath,
            consultUrl: obj.consultUrl,
            oldId:obj.oldId,
            ddUserId:obj.ddUserId,
        }
    })
}

// 设置指定管理员密码
export function SettingPassword(obj) {
    return request2({
        url: '/api2/TZsbAdminApi/Admin/SettingPassword',
        method: 'post',
        data: {
            id: obj.id,
            passWord: obj.passWord,
            passWordConfirm: obj.passWordConfirm
        }
    })
}

// 修改密码 /TZsbAdminApi/Admin/SettingPasswordTo
// export function SettingPasswordTo(obj) {
//     return request2({
//         url: '/api2/TZsbAdminApi/Admin/SettingPasswordTo',
//         method: 'post',
//         data: {
//             id: obj.id,
//             passWord: obj.passWord,
//             passWordConfirm: obj.passWordConfirm
//         }
//     })
// }
export function SettingPasswordTo(obj) {
    return request2({
        url: '/api7/SBCenterAdminApi/Admin/SettingPassword',
        method: 'post',
        data: {
            id: obj.id,
            passWord: obj.passWord,
            passWordConfirm: obj.passWordConfirm
        }
    })
}

// 删除管理员
export function deletAdmin(id) {
    return request2({
        url: '/api2/TZsbAdminApi/Admin/Delete',
        method: 'post',
        params: {
            id: id
        }
    })
}

// 获取角色名称列表
export function getRuleName() {
    return request2({
        url: '/api7/SBCenterAdminApi/Roles/GetRuleNameList?project=' + ProjectId,
        method: 'get',
    })
}


//获取指定管理员
export function getAdminList(obj) {
    obj.project = ProjectId;
    return request2({
        url: 'api7/SBCenterAdminApi/AdminRelevance/GetAdminRolesHeaders',
        method: 'post',
        data: obj
    });
}


//** 管理员登录日志页面
// 获取登陆记录
export function getAdminLoginRecordList(obj) {
    return request2({
        url: '/api2/TZsbAdminApi/AdminLoginRecord/GetPage',
        method: 'get',
        params: {
            AdminId: obj.adminId,
            PageSize: obj.pageSize,
            PageIndex: obj.pageIndex,
            LoginType:obj.loginType,
            IsLoginFail:obj.isLoginFail,
            LoginDesc:obj.LoginDesc,
            LoginCityName:obj.LoginCityName,
            RolesId:obj.rolesId
        }
    })
}

//删除登陆记录
export function deleteLoginRecord(ids) {
    return request2({
        url: 'api2/TZsbAdminApi/AdminLoginRecord/Deletes',
        method: 'post',
        data: ids
    });
}

// 管理员操作记录页面
export function GetPageList(obj) {
    let length = obj.OperationTypeId.length || 0
    let Ids = ''
    for (let i = 0; i < length; i++) {
        if (i == length - 1) {
            Ids += `OperationTypeId=${obj.OperationTypeId[i]}`
        } else {
            Ids += `OperationTypeId=${obj.OperationTypeId[i]}&`
        }
    }
    return request2({
        url: `/api2/TZsbAdminApi/Admin/GetPageList?${Ids}`,
        method: 'get',
        params: {
            // OperationTypeId: obj.OperationTypeId,
            StartTime: obj.StartTime,
            EndTime: obj.EndTime,
            KeyWord: obj.KeyWord,
            pageSize: obj.pageSize,
            pageIndex: obj.pageIndex
        }
    })
}

//生成指定URL的二维码图片--用户扫二维码之后会跳转到指定的URL上
export function getWeiXinImageOpen(adminId) {
    return request2({
        url: 'api2/TZsbWebAdminApi/AdminWchat/WeiXinImageOpen',
        method: 'get',
        responseType: 'blob',
        params: {
            adminId: adminId
        }
    });
}

//生成指定URL的二维码图片--用户扫二维码之后会跳转到指定的URL上
export function getWeiXinAdminImageOpen(adminId) {
    return request2({
        url: 'api2/TZsbWebAdminApi/AdminHhWchat/WeiXinImageOpenHh',
        method: 'get',
        responseType: 'blob',
        params: {
            adminId: adminId
        }
    });
}

//管理员取消微信关注
// export function cancelAttention (adminId) {
//   return request2({
//     url: 'api2/TZsbWebAdminApi/AdminWchat/CancelAttention',
//     method: 'get',
//     params: {
//       adminId: adminId
//     }
//   });
// }
// 设置管理员在职状态 
export function SetAdminState(adminId, adminState) {
    // let query = ''
    // adminId.forEach((item, index) => {
    //     if (index === adminId.length - 1) {
    //         query += 'adminIds=' + item
    //     } else {
    //         query += 'adminIds=' + item + '&'
    //     }
    // })
    return request2({
        url: 'api2/TZsbAdminApi/Admin/SetAdminState',
        method: 'post',
        data: {
            adminIds:adminId,
            adminState: adminState
        }
    });
}

// 登录指定管理员效验
export function LoginAdminSystem() {
    return request2({
        url: 'api2/TZsbAdminApi/Admin/LoginAdminSystem',
        method: 'get',
    });
}
// 基于老师id获取老师登录票据 登录指定管理员新 /SBCenterAdminApi/Admin/GetAdminLoginTokenAsync
export function GetAdminLoginTokenAsync(adminId,IsNewWindow,userAgent) {
    return request2({
        url: 'api7/SBCenterAdminApi/Admin/GetAdminLoginTokenAsync',
        method: 'get',
        params:{
            adminId:adminId,
            IsNewWindow:IsNewWindow?IsNewWindow:false,
            userAgent:userAgent?userAgent:null,
            rolesId: sessionStorage.getItem('AdminCache') ? JSON.parse(sessionStorage.getItem('AdminCache')).rolesId : 0
        }
    });
}

export function GetAdminLoginToken(data) {
	return request1({
		url: '/api7/SBCenterWebApi/AdminLogin/GetAdminLoginToken',
		method: 'get',
		params: data,
	})
}
// 批量修改所属上级
export function BatchSetSuperiors(data) {
    return request2({
        url: 'api2/TZsbAdminApi/Admin/BatchSetSuperiors',
        method: 'post',
        data:data
    });
}

// 获取管理员微信列表 /TZsbAdminApi/Admin/GetAdminWeiXinByAdminId
export function GetAdminWeiXinByAdminId(adminId){
    return request2({
        url: 'api2/TZsbAdminApi/Admin/GetAdminWeiXinByAdminId',
        method: 'get',
        params:{
            adminId
        }
    })
}

// 获取管理员微信详情 /TZsbAdminApi/Admin/GetAdminWeiXin
export function GetAdminWeiXin(id){
    return request2({
        url: 'api2/TZsbAdminApi/Admin/GetAdminWeiXin',
        method: 'get',
        params:{
            id
        }
    })
}

// 编辑指定管理员微信 /TZsbAdminApi/Admin/EditAdminWeixin
export function EditAdminWeixin(data) {
    return request2({
        url: 'api2/TZsbAdminApi/Admin/EditAdminWeixin',
        method: 'post',
        data:data
    });
}

// 添加指定管理员微信 /TZsbAdminApi/Admin/AddAdminWeixin
export function AddAdminWeixin(data) {
    return request2({
        url: 'api2/TZsbAdminApi/Admin/AddAdminWeixin',
        method: 'post',
        data:data
    });
}
// /TZsbAdminApi/Admin/GetAdminListTwo
export function GetAdminListTwo(obj) {
    return request2({
        url: 'api2/TZsbAdminApi/Admin/GetAdminListTwo',
        method: 'post',
        data: obj
    });
}
// 获取登陆类型
export function GetLoginTypesEnum() {
    return request2({
        url: 'api2/TZsbAdminApi/AdminLoginRecord/GetLoginTypesEnum',
        method: 'get',
    });
}
// 获取跳转成人类系统的 key
export function GetAdultSystemKey(data) {
    return request1({
        url: 'api5/Default/PostHhInfo',
        method: 'post',
        data
    })
}

// 获取钉钉id
export function GetDepartmentListByName(data) {
    return request2({
        url: 'api2/TZsbAdminApi/DingTalk/GetDepartmentListByName',
        method: 'get',
        data
    })
}

// 查看指定老师账号的日志列表
export function GetAdminDataChangeRecordList(params) {
    return request2({
        url: 'api2/TZsbAdminApi/AdminDataChangeRecord/GetAdminDataChangeRecordList',
        method: 'get',
        params
    })
}

// 关联钉钉账号——用于后台管理中心右上角
export function SetAdminDDUser(obj) {
    return request2({
      url: '/api2/TZsbAdminApi/Admin/SetAdminDDUser',
      method: 'post',
      params: {
        adminId: obj.adminId,
        ddUserId: obj.ddUserId,
      }
    })
  }